// extracted by mini-css-extract-plugin
module.exports = {"advMarketCard":"index-module_advMarketCard__gmym","rights":"index-module_rights_24V4i"};